import React from "react";
import { Button, Typography, Box, useMediaQuery} from "@mui/material";
import { useLanguage } from "../context/LanguageContext.js";
import { useNavigate } from "react-router-dom";
import { logDev } from "../utils/logger.js";
import { Link } from "react-router-dom";

const BoutonPaiement = ({ groupeId, nomGroupe, erreurNom }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const isMobile = useMediaQuery("(max-width:600px)");

  const id = groupeId 
  || sessionStorage.getItem("groupeId") 
  || sessionStorage.getItem("paiementTel");;
  
  const condition = !!id && erreurNom?.toLowerCase().includes("quota")||
  erreurNom?.toLowerCase().includes("essai");

  // 🔎 Log pour savoir si le bouton doit s’afficher
  logDev("[BoutonPaiement] état", { id, erreurNom, condition });

  if (!condition) return null;

  return (
    <Box sx={{ mt: 1 }}>
      <Typography
      sx={{
        fontWeight: "bold",
        color: "#d4af37", // doré
        padding: "8px 12px",
        borderRadius: "6px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
        backgroundImage: "radial-gradient(circle at top left, rgba(255,255,255,0.05), transparent 70%)",
        fontSize: isMobile ? "0.7rem" : "0.9rem",
        textAlign: "center"
      }}>
        {t("GroupeOneQuotaReached")}
      </Typography>
      <Button
      component={Link}
      to={id && id.match(/^[a-f0-9]{24}$/)
        ? `/paiement?groupeId=${id}&nom=${encodeURIComponent(nomGroupe)}`
        : `/paiement?tel=${encodeURIComponent(id)}&nom=${encodeURIComponent(nomGroupe)}`
      }
      variant="outlined"

       
      sx={{ 
        width: "100%",
        color: "#fff",  
        mt: 1,
        backgroundColor: "#3399FF !important",
        borderColor: "#3399FF", 
        display: "flex",
        fontSize: isMobile ? "0.5rem" : "0.7rem",
        fontWeight: "bold",
        transition: "all 0.3s ease",
        minHeight: isMobile ? "32px" : "40px",
        textAlign: "center",
        marginTop: 2,
        borderRadius: 1,
        '&:hover': {
          backgroundColor: "#027bb5 !important",  // fond au survol
          color: "#fff",               // texte au survol
          transform: "scale(1.05)"
        },
      }}
      >
      {t('SeeReactivationOrSubscritpionOptions')}
      </Button>
    </Box>
  );
};

export default BoutonPaiement;
